// Shared Daily Entry payload builder + save-error formatter. Used by single,
// bulk, mobile and template-import save paths so every write has one shape.
const ZERO_ATT = { balVatika: 0, primary: 0, upperPrimary: 0, highSchool: 0 };
const NO_MDM_FIELDS = ["noMdmReason", "noMdmReasonOther", "orderNo", "orderDate", "remarks", "studentsPresentRecord"];
const num = (v) => (Number.isFinite(Number(v)) ? Number(v) : 0);

export function buildDailyPayload(draft) {
  const dayKind = draft.dayKind === "working_no_mdm" || draft.dayKind === "holiday" ? draft.dayKind : "working";
  const out = { schoolId: draft.schoolId, date: draft.date, dayKind, notes: draft.notes || "" };
  if (draft.id) out.id = draft.id;
  if (dayKind !== "working") {
    out.entryType = "mdm";
    out.attendance = { ...ZERO_ATT };
    out.ingredients = [];
  } else {
    const a = draft.attendance || {};
    out.entryType = draft.entryType === "dryration" ? "dryration" : "mdm";
    out.attendance = { balVatika: num(a.balVatika), primary: num(a.primary), upperPrimary: num(a.upperPrimary), highSchool: num(a.highSchool) };
    out.ingredients = (draft.ingredients || []).filter(
      (i) => (i.name || "").trim() !== "" && (num(i.quantity) > 0 || num(i.rate) > 0),
    );
  }
  if (dayKind === "working_no_mdm") {
    NO_MDM_FIELDS.forEach((k) => { if (draft[k] !== undefined && draft[k] !== null && draft[k] !== "") out[k] = draft[k]; });
  }
  return out;
}

export function saveErrorMessage(err) {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string" && detail.trim()) return detail;
  if (Array.isArray(detail) && detail.length) {
    return detail.map((d) => String(d?.msg || d).replace(/^Value error,\s*/, "")).join(" · ");
  }
  return "Save failed — please retry · ସେଭ୍ ହେଲା ନାହିଁ, ପୁଣି ଚେଷ୍ଟା କରନ୍ତୁ";
}

// Bring the No-MDM reason chips clear of the sticky save bar (mobile) / into view (desktop).
export function scrollReasonBlockIntoView() {
  setTimeout(() => {
    const el = [...document.querySelectorAll('[data-testid="m-no-mdm-reason-block"], [data-testid="no-mdm-reason-block"]')]
      .find((n) => n.offsetParent !== null);
    el?.scrollIntoView({ block: "center", behavior: "smooth" });
  }, 80);
}
